import React from 'react';
import { useLanguage } from '../../i18n/useLanguage';
import { StaticPage } from '../StaticPage';
import { MissedConnectionsContentDe } from './missedConnections/MissedConnectionsContentDe';
import { MissedConnectionsContentEn } from './missedConnections/MissedConnectionsContentEn';

export const MissedConnectionsPage: React.FC = () => {
  const { language } = useLanguage();
  return (
    <StaticPage titleKey="static.missedConnections">
      {language === 'de' ? <MissedConnectionsContentDe /> : <MissedConnectionsContentEn />}
    </StaticPage>
  );
};
